﻿import * as React from "react";
import { IActiveSectionProps } from "../../SmartToolsRoot";
import { IBaseSectionProps } from ".";
import { SmartSupport } from "../../SmartSupport";

export const SmartSupportSection: React.FunctionComponent<IBaseSectionProps> = (
    props,
): React.ReactElement => {
    const bindOnClick = (): void => {
        const smartSupportComponent: React.ReactNode = <SmartSupport />;

        const activeProps: IActiveSectionProps = {
            moduleID: props.moduleID,
            sectionType: props.sectionType,
            subWindow: {
                body: smartSupportComponent,
                horizontalPos: `Center`,
                isDominant: false,
                moduleID: props.moduleID,
                subWindowKey: `smartsupportWindow`,
                title: `Contact Metricell`,
                verticalPos: `Center`,
            },
        };

        props.toggleSection(activeProps, activeSectionsComparer);
    };

    // This function is passed to the toggleSection function, and is used check if the other active sections should be active or not.
    const activeSectionsComparer = (
        activeSections: IBaseSectionProps[],
    ): IBaseSectionProps[] => {
        for (let i = 0; i < activeSections.length; i++) {
            if (activeSections[i].sectionType === `SmartSupport`) {
                activeSections.splice(i, 1);
                i--;
            }
        }

        return activeSections;
    };

    const isActiveCSS: string = props.isActive ? `selected` : ``;

    return (
        <div className={`tab-section ${isActiveCSS}`} onClick={bindOnClick}>
            <img
                alt={props.name}
                src={`/Images/Icon?icon=${props.moduleID}&folder=Module`}
            />
        </div>
    );
};
